export default "__VITE_ASSET__dKrGPpmL__"